<template>
    <div>
        <button type="button" class="btn btn-sm btn-default flt-r" v-on:click="modal.show()">
            Edit
        </button>
        <div ref="theModal" class="modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <form class="modal-content" v-on:submit.prevent="submit">
                    <div class="block block-rounded block-transparent mb-0">
                        <div class="block-header block-header-default">
                            <h3 class="block-title">Edit Unit Price</h3>
                            <div class="block-options">
                                <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-fw fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content fs-sm">
                            <div class="mb-4" v-for="(row, index) in calculation" :key="index">
                                <div class="input-group" v-if="row.type == 'pounds'">
                                    <span class="input-group-text">&pound;</span>
                                    <input type="text" class="form-control" v-model="row.value">
                                </div>
                                <div class="input-group" v-else-if="row.type == 'total_placeholder'">
                                    <span class="input-group-text">&pound;</span>
                                    <input type="text" class="form-control" v-model="row.value" readonly>
                                </div>
                                <div class="input-group" v-else-if="row.type == 'hours'">
                                    <input type="text" class="form-control" v-model="row.value">
                                    <span class="input-group-text">hours</span>
                                </div>
                                <div class="input-group" v-else-if="row.type == 'percentage'">
                                    <input type="text" class="form-control" v-model="percentifiedValue">
                                    <span class="input-group-text">%</span>
                                </div>
                                <input v-else type="text" class="form-control" v-model="row.value">
                            </div>

                            <div class="mb-4">
                                <label class="form-label">Total</label>
                                <div class="input-group">
                                    <span class="input-group-text">&pound;</span>
                                    <input type="text" readonly class="form-control" v-model="total">
                                </div>
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-sm btn-success">Update</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';

export default {
    props: {
        lineItem: {
            type: Object,
            required: true,
        },
        saveRoute: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            calculation: [],
            modal: null,
            total: 0,
        };
    },
    computed: {
        percentifiedRow () {
            return this.calculation.filter((row) => row.type == 'percentage')[0];
        },
        percentifiedValue: {
            get () {
                return this.percentifiedRow.value * 100;
            },
            set (value) {
                this.percentifiedRow.value = value / 100;
            }
        },
    },
    mounted () {
        this.modal = new Modal(this.$refs.theModal);

        // trigger watcher
        this.calculation = this.lineItem.unit_price_calculation;
    },
    watch: {
        calculation: {
            handler() {
                const values = this.calculation.map((row) => row.value);

                let multiplied = values.reduce((total, current) => total * current);

                this.total = new Intl.NumberFormat('en-UK', {style: 'currency', currency: 'GBP'}).format(multiplied);
            },
            deep: true,
        },
    },
    methods: {
        submit () {
            axios.post(this.saveRoute.replace('replace-me', this.lineItem.id), {
                calculation: this.calculation,
            }).then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'The invoice has been successfully updated',
                    showConfirmButton: true,
                }).then(() => location.reload());
            }).catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Unable to save invoice',
                });
            });
        },
    },
}
</script>

<style scoped>
    .flt-r {
        float:right;
    }
</style>
